import React from 'react';
import { Navigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const { currentTheme, theme } = useTheme();
  const spinnerColor = theme === 'dark' ? 'white' : 'black';

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          padding: 24,
          background: currentTheme.background,
        }}
      >
        <ClipLoader color={spinnerColor} size={32} aria-label="Loading" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;